import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import ReactGA from 'react-ga'

import aipng from '../../../assets/ActuaryImage.png'

export const TitlesPage = ({ThemeItems, themeListCount}) => {

    if(themeListCount == 0) {
        return <div>
                    Because we were not able to define a Job Passion Type, we are not able to define any Job Passion Titles.
                    Please contact <a href="mailto:support@careerzgroup.com" target="_blank">support@careerzgroup.com</a>
                    {' '} for assistance.
                </div>
        
    }

    return (
        <Container>
            <h1>Your Job Passion Titles&trade;</h1>
            <p>
                Employers typically post their job opportunities following the Standard Occupational
                Classification (SOC) code list. There are more than 850 occupation titles on this
                list, and we've linked each one to different Job Passion Types based on how well
                they match the Core and Supporting values that you'll need for success in that type.
            </p>
            <p>
                Because we've linked every relevant occupation title to each Job Passion Type, the
                result is a comprehensive list of job possibilities that you may never have
                considered before.
            </p>
            <p>
                The benefit of providing such a wide variety of options is to open up your mind to
                consider new career opportunities that could allow you to think broader or become
                unstuck from your current situation.
            </p>
            <p>
                However, because they cover the entire spectrum of possible job roles and industry
                sectors, you should expect that only a few of the suggestions on the list will be
                of interest to you.
            </p>
            <p>
                Here are the job title suggestions for up to five of your Job Passion Types:
            </p>

            <ThemeItems />

            <h2>What To Do Next</h2>
            <p>
                Start with the Job Passion Type that you feel is the best fit for you.
            </p>

            <div className="my-3">
                <Row className="align-items-center">
                    <Col xs="12" sm="4" md="3"><img className="d-block mw-100" src={aipng} alt={`Job Passion Discovery`} /></Col>
                    <Col className="mt-4">
                        <p>Carefully review the job title suggestions for that Job Passion Type.</p>
                        <p>
                            Click on any job title to pop up a description of that job role as shown
                            in this example for Actuary.
                        </p>
                        <p>
                            Create a shortlist of job title suggestions for you to investigate further
                            by entering a check mark beside the ones that resonate most with you.
                        </p>
                    </Col>
                </Row>
            </div>
            

            <h2>We're Here To Help</h2>
            <p>
                Whatever you need on your Job Passion Discovery journey, we're here to make sure you're successful.
                That's because we want you to be happy with your life. And, we know that lasting happiness is
                linked to finding work that fuels your passions and gives you a sense of purpose.
            </p>
            <p>
                To discover how we can help you leverage the results of your JPTI assessment to finally land
                a job that will be a dream for you to do, click the button below.
            </p>
            <p>
                <ReactGA.OutboundLink
                    eventLabel="discover_more"
                    to="https://careerzgroup.com/career-assessments/job-passion-type-indicator-JPTI/"
                    target="_blank"
                >
                    <button className="btn" style={
                        {
                            paddingTop: "10px", paddingBottom: "10px", paddingLeft: "15px", paddingRight: "15px",
                            fontWeight: "bold", color: "#2c3b59", backgroundColor: "#62CE62"}
                        }>DISCOVER MORE</button>
                </ReactGA.OutboundLink>
            </p>


        </Container>
    )
}
